import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/free-mode';

export default function Category_4depth({
  item,
  setFourDepCategoryNo,
  fourDepCategoryNo,
  twoDepCategoryNo,
  threeDepCategoryNo,
}: any) {
  return (
    <Category4Wrap>
      <div className="category4">
        <div className="inner">
          <SwiperWrap
            slidesPerView={'auto'}
            spaceBetween={12}
            breakpoints={{
              768: {
                spaceBetween: 20,
              },
            }}
            modules={[FreeMode]}
            freeMode={false}
            centeredSlidesBounds={true}
            slideToClickedSlide={true}
          >
            {item.map((el: any) => {
              return (
                <SwiperSlideItem key={el.categoryNo}>
                  <SlideItem
                    el={el}
                    setFourdepCategoryNo={setFourDepCategoryNo}
                    fourCategoryNo={fourDepCategoryNo}
                    twoDepCategoryNo={twoDepCategoryNo}
                    threeDepCategoryNo={threeDepCategoryNo}
                  ></SlideItem>
                </SwiperSlideItem>
              );
            })}
          </SwiperWrap>
        </div>
      </div>
    </Category4Wrap>
  );
}
export const Category4Wrap = styled.div`
  width: 100%;
  padding: 0 20px;
  background: var(--colWhite);
  border-bottom: 1px solid var(--colGray3);

  &.fixed {
    padding-bottom: 47px;
    & .swiper {
      position: fixed;
      top: 108px;
      left: 0;
      width: 100%;
      background-color: var(--colWhite);
      z-index: 10;
      padding: 0 20px;
      border-bottom: 1px var(--colGray3) solid;
    }
  }
  & div.category4 {
    padding: 0;
    & .inner {
      /* border-bottom: 1px solid var(--colGray3); */
    }
    & .swiper {
      & .swiper-slide div a {
        font-size: 16px;
        font-weight: 400;
        line-height: 18px;
        color: var(--colGray5);
      }
      & .swiper-slide div.on a {
        color: var(--colBlack);
      }
    }
  }

  @media screen and (min-width: 768px) {
    width: 100%;
    padding: 0;
    height: 50px;

    &.fixed {
      padding-bottom: 47px;
      & .inner {
        position: fixed;
        top: 132px;
        left: 0;
        width: 100%;
        background-color: var(--colWhite);
        z-index: 4;
        border-bottom: 1px solid var(--colGray3);

        & .swiper {
          position: relative;
          top: auto;
          left: auto;
          width: 1280px;
          margin: 0 auto;
          padding: 0 32px;
          border-bottom: none;
        }
      }
    }
    & div.category4 {
      max-width: 1280px;
      margin: 0 auto;
      padding: 0 32px;
    }
  }
`;
export const SwiperWrap = styled(Swiper)`
  & div.swiper-wrapper {
    & div.swiper-slide {
      width: auto !important;
      position: relative;
      & a {
        display: block;
        padding: 15px 2px;
        font-size: 15px;
        font-weight: 400;
        line-height: 18px;
        color: var(--colGray5);
      }
    }
    & div.on {
      a {
        color: var(--colBlack);
      }
    }
  }

  @media screen and (min-width: 768px) {
    & div.swiper-wrapper {
      & div.swiper-slide {
        width: auto !important;
        & div {
          & a {
            font-size: 16px;
            font-weight: 400;
            padding: 16px 2px;
            color: var(--colGray5);
          }
        }
        & div.on {
          & a {
            font-weight: 400;
            color: var(--colBlack);
          }
        }
      }
    }
  }
`;

export const SwiperSlideItem = styled(SwiperSlide)``;

export function SlideItem({ el, setFourdepCategoryNo, twoDepCategoryNo, fourCategoryNo, threeDepCategoryNo }: any) {
  const [selectCategory, setSelectCategory] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    if (fourCategoryNo === el.categoryNo) {
      setSelectCategory(true);
    } else {
      setSelectCategory(false);
    }
  }, [fourCategoryNo]);
  return (
    <div className={selectCategory ? 'on' : ''} key={el?.categoryNo}>
      <Link to={`/category/${twoDepCategoryNo}/${threeDepCategoryNo}/${el.categoryNo}`}>{el.label}</Link>
    </div>
  );
}
